<div class="bmc-sync-data__container">

    <div class="bmc-sync-data">
    </div>
    <p>
      {{'SYNC_FILES.DESCRIPTION' | translate}}
    </p>
    <div>
    <bzg-button-secondary class="bmc-sync-data__button" (click)="onExport()">
      {{'SYNC_FILES.EXPORT' | translate}}
    </bzg-button-secondary>
    </div>
  
  </div>
  
  <div class="bmc-sync-data__container-data">
    <ng-template #exportTemplate>
      <biz-export-sync-files (onFinish)="closeModalExport()"></biz-export-sync-files>
    </ng-template>
  
    <biz-sync-files-history [data]="exportHistory"></biz-sync-files-history>
  </div>
    